<div [ngClass]="{'kgrid-fullscreen' : enableFullscreen }">
    <kendo-grid [kendoGridBinding]="projectList" [sortable]="true" [resizable]="true" [filterable]="enableFilter" [reorderable]="true" [pageSize]="15" [pageable]="true" id="grvEDMProjectList" [height]="700" class="form-group-grid auto-complete-equal kg-hover-icon">
        <ng-template kendoPagerTemplate>
            <div class="k-pager-left">
                <kendo-pager-info></kendo-pager-info>
            </div>
            <div class="k-pager-right">
                <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                <kendo-pager-input></kendo-pager-input>
                <kendo-pager-next-buttons></kendo-pager-next-buttons>
            </div>
        </ng-template>
        <ng-template kendoGridToolbarTemplate>
            <div class="k-grid-toolbar-content d-flex">
                <div class="flex-grow-1 mat-panel-headerbar"></div>
                <div class="pagination-container">
                    <div class="btn-group" role="group" aria-label="Basic example">
                        <button type="button" class="btn btn-secondary" (click)="$event.stopPropagation();showEDRCList($event)">EDRC</button>
                        <button type="button" class="btn btn-secondary" (click)="$event.stopPropagation();showEipList($event)">EIP</button>
                        <kendo-popup [anchor]="eipAnchorElementPopup" [anchorAlign]="anchorAlignRight" [popupAlign]="popupAlignRight" (anchorViewportLeave)="IsShowEipList = false" *ngIf="IsShowEipList" style="width: 35%;">
                            <div class="eip-ml-10 eip-mr-10 eip-mt-10 eip-mb-10">
                                <div class="row">
                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12" #eipAuotCompleteDiv>
                                        <EIPAutoComplete #eipAutoComplete TextField="jobDesc" ValueField="jobCode" WaterMarkText="Job Desc" setId="eipJob" ShowTextValueField='Y' [dataSource]='jobList' [IsCascading]='true' (valueChange)='setSelectedJob($event)'>
                                        </EIPAutoComplete>
                                    </div>
                                </div>
                            </div>
                        </kendo-popup>
                        <kendo-popup [anchor]="edrcAnchorElementPopup" [anchorAlign]="anchorAlignRight" [popupAlign]="popupAlignRight" (anchorViewportLeave)="IsShowEDRCList = false" *ngIf="IsShowEDRCList" style="width: 35%;">
                            <div class="eip-ml-10 eip-mr-10 eip-mt-10 eip-mb-10">
                                <div class="row">
                                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12" #edrcAuotCompleteDiv>
                                        <EIPAutoComplete #edrcAutoComplete TextField="proj_Description" ValueField="proj_Code" WaterMarkText="Job Desc" setId="edrcJob" ShowTextValueField='Y' [dataSource]='edrcJobList' [IsCascading]='true' (valueChange)='setSelectedEDRCJob($event)'>
                                        </EIPAutoComplete>
                                    </div>
                                </div>
                            </div>
                        </kendo-popup>
                        <button type="button" class="btn btn-secondary" (click)="$event.stopPropagation();addEditProject()">Other</button>
                    </div>
                </div>
                <div class="divider-container d-none d-md-block" id="imgDivider">
                    <span></span>
                </div>
                <div class="pagination-container">
                    <p id="lblShowDetails">Show</p>
                    <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                    </kendo-pager-page-sizes>
                    <span>Items</span>
                </div>
                <div class="divider-container d-none d-md-block" id="imgDivider">
                    <span></span>
                </div>
                <div class="icons-container">
                    <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                    <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                        <div class="icon-wrap" (click)="toggleFilter()">
                            <i class="fa fa-filter" title="Filter" aria-hidden="true"></i>
                            <span class="list-icon-name">Filter</span>
                        </div>
                        <div class="icon-wrap" (click)="toggleFullscreen()">
                            <i class="fa " [ngClass]="enableFullscreen ? 'fa-compress': ' fa-expand'" aria-hidden="true" title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}"></i>
                            <span class="list-icon-name">{{ !enableFullscreen ? 'Expand' : 'Collapse' }}</span>
                        </div>
                    </div>
                    <div class="divider-container"><span></span></div>
                    <i class="fa fa-plus-circle icon-my-10" title="Add Project" aria-hidden="true" (click)="addEditProject()"></i>
                </div>
            </div>
        </ng-template>
        <kendo-grid-column title="Sl.No." filterable="false" [width]="60">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                {{rowIndex+1}}
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Project Code" field="project_Code" [width]="110">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.project_Code}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.project_Code}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Job Code" field="job_Code" [width]="110">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.job_Code}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.job_Code}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Short Description" field="project_Short_Description" [width]="110">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.project_Short_Description}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.project_Short_Description}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Description" field="project_Description" [width]="400">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.project_Description}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.project_Description}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="IC" field="ic_Description" [width]="150">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.ic_Description}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.ic_Description}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Created By" field="created_By" [width]="110">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.created_By}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.created_By}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Created On" field="created_On" [width]="110">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <span class="no-wrap" eipTooltip="{{dataItem.created_On| date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.created_On| date:'dd-MMM-yyyy'}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Modified By" field="modified_By" [width]="110">
            <ng-template kendoGridCellTemplate let-dataItem>
                <span class="no-wrap" eipTooltip="{{dataItem.modified_By}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.modified_By}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Modified On" field="modified_On" [width]="110">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <span class="no-wrap" eipTooltip="{{dataItem.modified_On| date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto" style="display: block;word-wrap:break-word;white-space: normal;">{{dataItem.modified_On| date:'dd-MMM-yyyy'}}</span>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Is Active" [width]="80" field="is_Active">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [checked]="dataItem.is_Active" [disabled]="true" [size]="smaller"></kendo-switch>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column title="Action" [width]="100">
            <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex" style="cursor: pointer;">
                <div #divIcon class="icon-container">
                <i class="fa fa-pencil icon-my-10 eip-link" style="font-size: 1.25em; cursor: pointer;" (click)="addEditProject(dataItem)" aria-hidden="true"  title="Edit Project" id="btnEDMEdit"></i>&nbsp;&nbsp;
                <i class="fa fa-clone icon-my-10 eip-link" style="font-size: 1.25em; cursor: pointer;" (click)="EnableSimilarProject(dataItem)" aria-hidden="true"  title="Enable Similar Project" id="btnEDMclone"></i>
            </div>
            </ng-template>
        </kendo-grid-column>
    </kendo-grid>
</div>